const fullEleInvoiceIsAbnormalConfig = {
    version: 1.19,
    queryForm: [
        {
            label: '发票种类',
            selected: false,
            default: false,
            name: 'invoiceType',
            type: 'dict',
            dict: 'ivat_inv_add_type',
        },
        {
            label: '发票状态',
            selected: false,
            default: false,
            name: 'invoiceStatus',
            type: 'dict',
            dict: 'ivat_invoice_status',
        },
        {
            label: '税局入账用途',
            selected: true,
            default: true,
            name: 'entryPurposeStatus',
            sort: true,
            type: 'dict',
            dict: 'entry_purpose_status',
        },
        {
            label: '发票代码',
            selected: true,
            default: true,
            name: 'invoiceCode',
            sort: true,
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            name: 'invoiceNumber',
            sort: true,
        },
        {
            label: '数电发票号',
            selected: true,
            default: true,
            name: 'electricInvoiceNum',
            sort: true,
        },
        {
            label: '开票日期',
            selected: true,
            default: true,
            type: 'date',
            name: 'invoiceDate',
            sort: true,
        },
        {
            label: '销方名称',
            selected: true,
            default: true,
            sort: true,
            name: 'saleName',
        },
        {
            label: '销方纳税人识别号',
            selected: true,
            default: true,
            sort: true,
            name: 'saleCreditCode',
        },
        {
            label: '购方名称',
            selected: true,
            default: true,
            sort: true,
            name: 'custName',
        },
        {
            label: '购方纳税人识别号',
            selected: true,
            default: true,
            sort: true,
            name: 'custCreditCode',
        },
        {
            label: '来源系统',
            selected: true,
            default: true,
            name: 'sourceSystem',
            sort: true,
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '机构名称',
            selected: true,
            default: true,
            name: 'orgName',
            type: 'org',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            name: 'departmentNo',
            dict: 'department_no',
            type: 'dict',
        },
        {
            label: '主管税局省市',
            selected: false,
            default: false,
            name: 'province',
            type: 'taxBureauId',
        },
        {
            label: '入账月份',
            sort: false,
            selected: true,
            default: true,
            name: 'paymentMonthStr',
            type: 'rzyf',
        },
        {
            label: '企业入账时间',
            sort: false,
            selected: false,
            default: false,
            name: 'entryOperateTime',
            type: 'date',
        },
        {
            label: '企业入账用途',
            selected: true,
            default: true,
            sort: false,
            type: 'companyEntryStatus',
        },
        {
            label: '入账过程',
            selected: true,
            default: true,
            sort: false,
            type: 'entryRequestStatus',
        },{
            label: '业务单据号',
            sort: false,
            selected: false,
            default: false,
            name: 'claimNumber',
        },{
            label: '来源系统编码',
            selected: false,
            default: false,
            name: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
    table: [
        {
            label: '来源系统',
            selected: true,
            default: true,
            name: 'sourceSystem',
            sort: false,
            type: 'dict',
            dict: 'interface_source_system',
        },
        {
            label: '发票种类',
            selected: true,
            default: true,
            name: 'invoiceType',
            sort: false,
            type: 'dict',
            dict: 'ivat_inv_add_type',
        },
        {
            label: '发票代码',
            selected: true,
            default: true,
            name: 'invoiceCode',
            sort: false,
        },
        {
            label: '发票号码',
            selected: true,
            default: true,
            name: 'invoiceNumber',
            sort: false,
        },
        {
            label: '数电发票号',
            selected: true,
            default: true,
            name: 'electricInvoiceNum',
            sort: false,
        },
        {
            label: '开票日期',
            selected: true,
            default: true,
            name: 'invoiceDate',
            sort: false,
        },
        {
            label: '发票状态',
            selected: true,
            default: true,
            name: 'invoiceStatus',
            sort: false,
            type: 'dict',
            dict: 'ivat_invoice_status',
        },
        {
            label: '税局入账用途',
            selected: true,
            default: true,
            name: 'entryPurposeStatus',
            sort: false,
            type: 'dict',
            dict: 'entry_purpose_status',
        },
        {
            //5
            label: '税局入账日期',
            selected: true,
            default: true,
            name: 'entryDate',
            sort: false,
        },
        {
            label: '入账描述',
            selected: false,
            default: false,
            sort: false,
            name: 'entryFailDesc',
        },
        {
            label: '销方名称',
            selected: true,
            default: true,
            sort: false,
            name: 'saleName',
        },
        {
            label: '销方纳税人识别号',
            selected: true,
            default: true,
            sort: false,
            name: 'saleCreditCode',
        },
        {
            label: '购方名称',
            selected: true,
            default: true,
            sort: false,
            name: 'custName',
        },
        {
            label: '购方纳税人识别号',
            selected: true,
            default: true,
            sort: false,
            name: 'custCreditCode',
        },
        {
            //10
            label: '金额',
            sort: false,
            selected: true,
            default: true,
            name: 'amount',
        },
        {
            label: '税额',
            sort: false,
            selected: true,
            default: true,
            name: 'taxAmount',
        },
        {
            label: '价税合计',
            sort: false,
            selected: false,
            default: false,
            name: 'adValoremTotal',
        },
        {
            label: '业务单据号',
            sort: false,
            selected: false,
            default: false,
            name: 'claimNumber',
        },
        {
            label: '企业入账用途',
            selected: true,
            default: true,
            name: 'companyEntryStatus',
            sort: false,
            type: 'dict',
            dict: 'entry_purpose_status',
        },
        {
            label: '入账月份',
            sort: false,
            selected: true,
            default: true,
            name: 'paymentMonth',
        },
        {
            label: '企业入账时间',
            sort: false,
            selected: false,
            default: false,
            name: 'entryOperateTime',
        },
        {
            label: '入账过程',
            selected: true,
            default: true,
            name: 'entryRequestStatus',
            sort: false,
            type: 'dict',
            dict: 'entry_request_status',
        },
        {
            label: '机构名称',
            selected: true,
            default: true,
            name: 'orgName',
            sort: false,
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            name: 'departmentNo',
            dict: 'department_no',
            type: 'dict',
        },
        {
            label: '所属区域',
            selected: false,
            default: false,
            sort: false,
            name: 'regionName',
        },
        {
            label: '管理城市',
            selected: false,
            default: false,
            sort: false,
            name: 'cityName',
        },
        {
            label: '主管税局所在省市',
            selected: false,
            default: false,
            sort: false,
            name: 'province',
        },
        {
            label: '发票来源',
            selected: false,
            default: false,
            name: 'invoiceSource',
            dict: 'red_confirm_invoice_source',
            type: 'dict',
        },
        {
            label: '录入日期',
            selected: false,
            default: false,
            name: 'inputDate',
        },{
            label: '来源系统编码',
            selected: false,
            default: false,
            name: 'sourceAppId',
            type: 'dict',
            dict: 'ivat_source_app_id',
        },
    ],
}

export default fullEleInvoiceIsAbnormalConfig



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/InvAccountManagement/fieldConfig.js